import useAuthentication from '@/hooks/useAuthentication/useAuthentication';
import { useQueryParams } from '@/hooks/useQueryParams/useQueryParams';
import { useState } from 'react';
import Button from '../Button/Button';
import { ButtonAlign } from '../Button/consts';
import Clickable from '../Clickable/Clickable';
import { ClickableAction } from '../Clickable/consts';
import Icon from '../Icon/Icon';
import Lightbox from '../Lightbox/Lightbox';
import styles from './BenefitsSuggestionCard.module.scss';
import {
    BenefitsSuggestionCardForm
} from './BenefitsSuggestionCardForm/BenefitsSuggestionCardForm';

import type { BenefitsSuggestionCardProps } from './types';

const TITLE = 'Fehlt Ihnen ein Partnerangebot?';
const BUTTON_LABEL = 'Jetzt vorschlagen';

const BenefitsSuggestionCard = (props: BenefitsSuggestionCardProps) => {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const { isAuthenticated, user, openAuthenticationModal } =
    useAuthentication();
  const { params } = useQueryParams();
  const email =
    props.email ||
    params?.__user_email?.toString() ||
    (isAuthenticated && user?.email) ||
    undefined;

  const toggleLightbox = () => {
    setIsLightboxOpen((isLightboxOpen) => !isLightboxOpen);
  };

  const handleOnClick = () => {
    if (email) {
      toggleLightbox();
      return;
    }

    openAuthenticationModal({
      modalReason: 'benefitsSuggestion',
      loginCallback: () => {
        toggleLightbox();
      },
    });
  };

  return (
    <>
      <Clickable
        actionType={ClickableAction.Custom}
        onClick={handleOnClick}
        className={styles.base}
        tabIndex={1}
        customDataLayer={{
          clickContext: TITLE,
          customClickText: BUTTON_LABEL,
          customClickElementType: 'BenefitsSuggestionCard',
        }}
      >
        <div className={styles.card}>
          <div className={styles.iconWrapper}>
            <Icon variant="action/plus" size="iconSize32" />
          </div>
          <p className={styles.title}>{TITLE}</p>

          <Button
            actionType={ClickableAction.None}
            className={styles.button}
            align={ButtonAlign.Center}
            noClickable
            asDiv
          >
            {BUTTON_LABEL}
          </Button>
        </div>
      </Clickable>

      {!!email && (
        <Lightbox
          onClose={toggleLightbox}
          showCloseIcon={false}
          active={isLightboxOpen}
        >
          <BenefitsSuggestionCardForm onClose={toggleLightbox} email={email} />
        </Lightbox>
      )}
    </>
  );
};

export default BenefitsSuggestionCard;
